export interface ItemLegenda {
  id: string
  cor: string
  rotulo: string
  valor?: string
  tracejado?: boolean
}

/** Legenda flutuante das zonas sobre o canvas. Cor sempre acompanhada de texto. */
export function LegendaZonas({ titulo, itens }: { titulo: string; itens: readonly ItemLegenda[] }) {
  return (
    <aside className="legenda-zonas" aria-label={titulo}>
      <strong>{titulo}</strong>
      <ul>
        {itens.map((item) => (
          <li key={item.id}>
            <i
              aria-hidden="true"
              style={item.tracejado ? { borderColor: item.cor, borderStyle: 'dashed', background: 'transparent' } : { background: item.cor, borderColor: item.cor }}
            />
            <span>{item.rotulo}</span>
            {item.valor && <b>{item.valor}</b>}
          </li>
        ))}
      </ul>
    </aside>
  )
}
